import { ComponentProps, PropsWithChildren } from 'react';

import { cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

interface ItemProps extends PropsWithChildren {
  className?: string;
  title: string;
  isCustomValue?: boolean;
  color?: ComponentProps<typeof Typography>['color'];
}

const Item = ({
  className,
  children,
  color = 'default',
  title,
  isCustomValue,
}: ItemProps) => {
  return (
    <div
      className={cn(
        'flex h-full w-full items-start justify-between gap-x-2',
        className,
      )}
    >
      <Typography variant="16-m" color="text-base-100">
        {title}
      </Typography>

      {isCustomValue ? (
        children
      ) : (
        <Typography
          className="max-w-[220px] break-words text-end"
          color={color}
          variant="16-r"
        >
          {children}
        </Typography>
      )}
    </div>
  );
};

export const TransactionDetailGroup = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        'flex min-h-20 flex-col items-center justify-center gap-y-6 rounded-3xl bg-base-300 px-5 py-4 last:mb-4',
        className,
      )}
    >
      {children}
    </div>
  );
};

TransactionDetailGroup.Item = Item;
